import ApiService from '@boServices/apiService';

class UserService extends ApiService {
    getUsers({ role } = {}) {
        const params = new URLSearchParams();
        if (role) params.set('role', role);
        const query = params.toString();
        return this.fetchWithHeaders(`/api/v2/backoffice/users${query ? `?${query}` : ''}`, 'GET');
    }

    getMe() {
        return this.fetchWithHeaders('/api/v2/backoffice/users/me', 'GET');
    }

    updateMe(profile) {
        return this.fetchWithHeaders('/api/v2/backoffice/users/me', 'PUT', {
            body: JSON.stringify(profile),
        });
    }

    createUser(user) {
        return this.fetchWithHeaders('/api/v2/backoffice/users', 'POST', {
            body: JSON.stringify(user),
        });
    }

    updateUser(userId, user) {
        return this.fetchWithHeaders(`/api/v2/backoffice/users/${userId}`, 'PUT', {
            body: JSON.stringify(user),
        });
    }

    deleteUser(userId) {
        return this.fetchWithHeaders(`/api/v2/backoffice/users/${userId}`, 'DELETE');
    }
}

export default UserService;
